export default {
    mapper: {
        relations: {
            belongsTo: {
                user: {
                    foreignKey: 'user_user',
                    localField: 'user',
                },
            },
        },
    },
};
